import React, { useEffect, useContext } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { HeaderProvider } from "../../contexts/HeaderContext";
import { AuthContext, AuthConsumer } from "../../lib/contexts/AuthContext";
import { AppShell } from "./AppShell";

export default function Layout(props) {
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);

  useEffect(() => {
    if (authContext && !authContext.isAuthenticated()) {
      navigate("/login");
    }
  }, [authContext, navigate]);

  return (
    <AuthConsumer>
      {(context) => (
        <HeaderProvider>
          <AppShell>{props.children}</AppShell>
        </HeaderProvider>
      )}
    </AuthConsumer>
  );
}

export const LayoutRoute = ({ component: Component, ...rest }) => {
  return (
    <Routes>
      <Route
        {...rest}
        element={
          <Layout>
            <Component />
          </Layout>
        }
      />
    </Routes>
  );
};
